import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/dashboard.css";
import React from "react";
import Layout from "./Layout";

function Dashboard() {
    return (
        <Layout>
            {/* Contenido del Dashboard aqui */}
        </Layout>
    );
}

export default Dashboard;